import { Box, Typography } from '@mui/material';
import type {
  SyberryTodayProjectAllocationSummary,
  SyberryTodayProject,
  SyberryTodayTaskId,
  SyberryTodayTaskGroup,
  SyberryTodayTaskStream,
  SyberryTodayWorkItem,
} from 'domain/people/syberryToday/types';
import { getTasksByStreamId } from '../../utils';
import SyberryTodayAllocationSummary from '../SyberryTodayAllocationSummary/SyberryTodayAllocationSummary';
import SyberryTodayBoardColumn from '../SyberryTodayBoardColumn/SyberryTodayBoardColumn';

type SyberryTodaySelectBoardProps = {
  activeGroup: Nullable<SyberryTodayTaskGroup>;
  activeProject: Nullable<SyberryTodayProject>;
  allocationSummary: Nullable<SyberryTodayProjectAllocationSummary>;
  isAllocationLoading: boolean;
  isAllocationError: boolean;
  streams: SyberryTodayTaskStream[];
  tasks: SyberryTodayWorkItem[];
  expandedTaskId: Nullable<SyberryTodayTaskId>;
  onToggleSelection: (taskId: SyberryTodayTaskId) => void;
  onToggleExpansion: (taskId: SyberryTodayTaskId) => void;
};

const SyberryTodaySelectBoard = ({
  activeGroup,
  activeProject,
  allocationSummary,
  isAllocationLoading,
  isAllocationError,
  streams,
  tasks,
  expandedTaskId,
  onToggleSelection,
  onToggleExpansion,
}: SyberryTodaySelectBoardProps) => (
  <Box component="main" minWidth={0} marginLeft={2.5} p={2.5} bgcolor="background.paper">
    <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={3} marginBottom={3}>
      <Box>
        <Typography component="h1" variant="h1" color="brand">
          {activeProject?.name ?? activeGroup?.name ?? 'Tasks'}
        </Typography>
        {activeProject && (
          <SyberryTodayAllocationSummary
            allocationSummary={allocationSummary}
            isLoading={isAllocationLoading}
            isError={isAllocationError}
          />
        )}
      </Box>
    </Box>

    <Box
      sx={{
        overflowX: 'auto',
        paddingBottom: 2,
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridAutoFlow: 'column',
          gridAutoColumns: 'minmax(360px, 400px)',
          gap: 6,
          width: 'max-content',
          minWidth: '100%',
          '@media (max-width: 900px)': {
            gridAutoColumns: 'minmax(300px, 85vw)',
            minWidth: '900px',
            gap: 2.5,
          },
        }}
      >
        {streams.map(stream => (
          <SyberryTodayBoardColumn
            key={stream.id}
            stream={stream}
            tasks={getTasksByStreamId(tasks, stream)}
            expandedTaskId={expandedTaskId}
            onToggleSelection={onToggleSelection}
            onToggleExpansion={onToggleExpansion}
          />
        ))}
      </Box>
    </Box>
  </Box>
);

export default SyberryTodaySelectBoard;
